import { put, call } from 'redux-saga/effects';
import { map, omit } from 'lodash';
import mulesoftDataService from '../../services/mulesoftData.services';
import { constants } from '../../constants';

import { 
  restInstitutionDetails,
  updateInstitutionDetailsFlag,
  toggleAlertShowStatus,
  setShowLoaderStatus} from '../actions';

export default function * saveInstitutionDetails (args) {
  try {
    const selectedInstitutionList = map(args.payload.identifiers, 'ResultsTeamChildId')
    yield call([mulesoftDataService, 'saveInstitutionDetails'], omit(
      {...args.payload, resultsTeamChildIds: selectedInstitutionList},
     ['callback','identifiers']));

    //making sure redux store will update if api save is successful
    yield put(updateInstitutionDetailsFlag());
    yield put(setShowLoaderStatus(false));
    args.payload.callback();
  } catch (error) {
    yield put(toggleAlertShowStatus({
      showAlert: true,
      alertVarient:'danger',
      alertMessage: constants.APP_MESSAGE.API_SAVE_ERROR
    }));

    // reseting personal info redux state when api error
    yield put(restInstitutionDetails());
    yield put(setShowLoaderStatus(false));
  }
}
